import { UserDetails, UserOrganisationDetails, UserSecurityDetails } from '../auth.data';
import type { UpdatePasswordInput } from 'aws-amplify/auth';

export const PASSWORD_POLICY_MIN_LENGTH = 10;
export const PASSWORD_POLICY_CONTAIN_LOWERCASE = true;
export const PASSWORD_POLICY_CONTAIN_UPPERCASE = true;
export const PASSWORD_POLICY_CONTAIN_NUMBER = true;
export const PASSWORD_POLICY_CONTAIN_SPECIAL_CHARACTER = true;

export abstract class AuthenticationService {
  public abstract openCognitoLoginPage(): void;

  public abstract handleAuthCallbackAndRedirectToIntendedUrl(): Promise<void>;

  public abstract isAuthenticatedQuickCheck(): boolean;

  public abstract isAuthenticated(): Promise<boolean>;

  public abstract storeUserDetails(user: unknown): void;

  public abstract getUserGravatarPath(userEmail?: string): string;

  public abstract hasRole(role: string): boolean;

  public abstract getUserRoles(): Array<string>;

  public abstract logout(): void;

  public abstract getUserSecurityDetails(): UserSecurityDetails;

  public abstract getUserDetails(): UserDetails;

  public abstract getUserOrganisationDetails(): UserOrganisationDetails;

  public abstract getAccessTokenAsync(): Promise<string>;

  public abstract changePassword({ oldPassword, newPassword }: UpdatePasswordInput): Promise<boolean>;
}
